const PricingMaster = {

    // FIELDS
    "sub_cat": "الفئة الفرعية",
    "brand": "العلامة التجارية",
    "effective_date": "تاريخ السريان",
    "effective_from": "ساري من",
    "customer": "العميل",
    "customer_cat": "فئة العميل",
    "item": "العنصر",
    "old_rate": "السعر القديم",
    "new_rate": "السعر الجديد",
    "remark": "ملاحظة",
    "search": "بحث",

    // PAGE HEADER
    "product_pricing": "تسعير المنتج",
    "customer_pricing": "تسعير العميل",
    "customer_cat_pricing": "تسعير فئة العميل",

    // SWEET ALERT
    "pricing_filter": "تصفية التسعير",
    "customer_pricing_filter": "تصفية تسعير العميل",
    "customer_category_pricing_filter": "تصفية تسعير فئة العميل",
    "pricing_filter_error": "اختر تاريخ السريان وأحد العلامة التجارية أو الفئة الفرعية",
    "customer_pricing_filter_error": "اختر العميل مع تاريخ السريان وأحد العلامة التجارية أو الفئة الفرعية",
    "customer_category_pricing_filter_error": "اختر فئة العميل مع تاريخ السريان وأحد العلامة التجارية أو الفئة الفرعية",

    // ERROR
    "error_sub_cat": "اختر الفئة الفرعية",
    "error_brand": "اختر العلامة التجارية",
    "error_date": "اختر التاريخ",
    "error_positive_no": "أدخل رقمًا موجبًا فقط",
    "error_rate": "أدخل السعر",
    "error_item_nf": "العنصر غير موجود",
    "error_customer": "اختر العميل",
    "error_customer_cat": "اختر فئة العميل",

    // TABLE HEADER
    "table_effective_date": "تاريخ السريان",
    "table_sub_cat": "الفئة الفرعية",
    "table_brand": "العلامة التجارية",
    "table_item": "العنصر",
    "table_price": "السعر",
    "table_customer": "العميل",
    "table_customer_cat": "فئة العميل",
}

export default PricingMaster;